<template lang="pug">
  footer
    .footer_bottom
      .container
        .row
          .col-xs-12.text-center
            nav.sns
              h4 Follow us
              ul
                li
                  a(href="https://www.instagram.com/taberutokurasuto/" target="_blank")
                    i(class="fa fa-instagram" aria-hidden="true")
                li
                  a(href="https://www.facebook.com/taberutokurasuto/" target="_blank")
                    i(class="fa fa-facebook" aria-hidden="true")
                li
                  a(href="https://twitter.com/taberutokurasut" target="_blank")
                    i(class="fa fa-twitter" aria-hidden="true")
            nav.footer_menu1
              ul
                li
                  a(href="/about/") たべるとくらすとについて
                li
                  a(href="/shops/") 生産者一覧
                li
                  a.ga_send.pmd-ripple-effect.cart_btn(v-if="hasShopCode" :href="`/shop/${shopCode}/contact/`" ) お問合せ
                  a.ga_send.pmd-ripple-effect.cart_btn(v-else href="/contacts/" ) お問合せ
                li
                  a(href="/columns/notice/") お知らせ
                li
                  a.ga_send.pmd-ripple-effect.cart_btn(href="/opencontacts/" ) 出店のお問合せ
                li
                  a.ga_send.pmd-ripple-effect.cart_btn(href="/sitemap/" ) サイトマップ
            nav.footer_menu2
              ul
                li
                  a(href="http://www.ess.nu/" target='_blank') 運営会社
                li
                  a(href="/terms/") 利用規約
                li
                  a(href="/privacy/") プライバシーポリシー
                li
                  a(:href="`/shop/${shopCode}/law/`") 特定商取引法に基づく表記

            p © {{new Date().getFullYear()}} たべるとくらすと

</template>

<script>
  export default {
    name: "footer",
    components: {
    },
    data: function () {
      return {
      }
    },
    computed: {
      shopCode() {
        return this.$route.params.shop_code || this.$route.params.adminShopCode || this.$route.params.admin_shop_code || 'tabekura'
      },
      hasShopCode() {
        return !!this.shopCode
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
